/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  导出: 'Export',
  设置: 'Setting',
  只查看: 'View Only',
  批量导出: 'Batch Export',
  编辑商机: 'Edit Opportunity',
  全局对象: 'Global Object',
  编辑报价单: 'Edit Quotation',
  作废报价单: 'Invalid Quotation',
  容联外呼人员: 'Ronglian Outbound Personnel',
  新增销售合同: 'Add Sales Contract',
  查看审批详情: 'View Approval Details',
  编辑销售合同: 'Edit Sales Contract',
  编辑售后服务: 'Edit After-sales Service',
  客户行业分布: 'Customer Industry Distribution',
  下载通话视角明细: 'Download Call Perspective Details',
  下载人员视角明细: 'Download Personnel Perspective Details',
  下载日程视角明细: 'Download Schedule Perspective Details',
  超2日待处理线索数量: 'Over 2 Days Pending Clue Quantity',
  '数据看板-线索分析': 'Data Dashboard - Clue Analysis',
  '数据看板-客户画像': 'Data Dashboard - Customer Portrait',
  '数据看板-成员榜单': 'Data Dashboard - Member Ranking',
  '分配线索数-飞书GBLeader': 'Assigned Clue Number - Feishu GBLeader',
  '添加/修改/删除客户关键联系人': 'Add/Modify/Delete Customer Key Contact',
  '新增/编辑/删除产品价格': 'Add/Edit/Delete Product Price',
  '新增销售订单(提交)': 'New Sales Order (Submit)',
  '新增/编辑产品': 'Add/Edit Product',
  '添加/编辑跟进': 'Add/Edit Follow-up',
  '添加/编辑联系人': 'Add/Edit Contact',
  '新增/管理协作人': 'Add/Manage Collaborators',
  '新增/编辑业绩参与人': 'Add/Edit Performance Participant',
  '新增/编辑地址信息': 'Add/Edit Address Information',
  '新增/编辑开票信息': 'Add/Edit Invoice Information',
  '新增/编辑/删除日程': 'Add/Edit/Delete Schedule',
  '新增销售订单(提交并按明细拆分)': 'New Sales Order (Submit and Split by Details)',
  '完成阶段/回退至该阶段/结束': 'Complete Stage/Rollback to This Stage/End',
  '上传/复制/下载/删除云文档附件': 'Upload/Copy/Download/Delete Cloud Document Attachment'
};
